import { Col, Modal, Row } from "antd";
import dayjs from "dayjs";
import React, { useMemo } from "react";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  small {
    color: #636980;
  }
`;

const DayInfo = ({ open, setOpen, data = {}, record = {} }) => {
  console.log("data", data);
  const weekendOptions = [
    { label: "All Saturdays and Sundays", value: "allsaturdayandsunday" },
    { label: "All Saturdays", value: "allsaturdays" },
    { label: "All Sundays", value: "allsundays" },
    { label: "All Days", value: "alldays" },
    { label: "No Weekends", value: "noweekends" },
  ];

  const transformData = useMemo(() => {
    return {
      Shift: data?.shifttitle || "-",
      "Shift Timing":
        data?.starts && data?.ends
          ? dayjs(data?.starts).format("hh:mm A") +
            " - " +
            dayjs(data?.ends).format("hh:mm A")
          : "-",

      Weekend:
        weekendOptions?.find((val) => val?.value === data?.isweekend)?.label ||
        "-",
      "Holiday as Working Day":
        data?.isholiday === "yes"
          ? "Yes"
          : data?.isholiday === "no"
          ? "No"
          : "-",
    };
  }, [data]);

  return (
    <div>
      <StyledModal
        title="Day Info"
        open={open}
        onCancel={() => setOpen(false)}
        width={500}
        footer={false}
      >
        <Row gutter={[8, 8]}>
          {Object.keys(transformData).map((key, index) => (
            <React.Fragment key={index}>
              <Col span={12}>
                {key}
                {key === "Shift Title" && (
                  <span
                    style={{
                      color: "#636980",
                      width: "20px",
                      height: "20px",
                      background: data?.color,
                    }}
                  ></span>
                )}
              </Col>
              <Col span={12}>
                {" "}
                <strong style={{ fontWeight: 500 }}>
                  {transformData[key]}
                </strong>
              </Col>
            </React.Fragment>
          ))}
          {record?.leavestatus && (
            <>
              <Col span={12}>Leave Applied</Col>
              <Col span={12}>
                {" "}
                <strong style={{ fontWeight: 500 }}>{record?.leavename}</strong>
              </Col>
              <Col span={12}>Leave Status</Col>
              <Col span={12}>
                {" "}
                <strong style={{ fontWeight: 500 }}>
                  {record?.leavestatus === "4" || record?.isammended === "1"
                    ? "Pending"
                    : "Approved"}
                </strong>
              </Col>
            </>
          )}
        </Row>
      </StyledModal>
    </div>
  );
};

export default DayInfo;
